import React, { useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Form, Row, Toast } from 'react-bootstrap';
import { useAppDispatch } from '../app/hooks';
import { getResetPasswordTokenAsync } from '../slices/profile.slice';
import solarSharelogo from '../assets/images/rex-logo.png';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const [succuss, setSuccess] = useState(false);
  const [failure, setFailure] = useState(false);
  const [hideNotification, setHideNotification] = useState(true);

  const handleSubmit = async () => {
    const response = await dispatch(getResetPasswordTokenAsync({ username: location.state.username }));
    const status: number = JSON.parse(JSON.stringify(response.payload));
    if (status === 201) {
      setSuccess(true);
    } else {
      setFailure(true);
    }
    setHideNotification(false);
  }

  return (
    <div className='login-main'>
      <Container className='h-100'>
        <Row className='justify-content-center align-items-center h-100'>
          <Col lg="7" md sm>
            <Card className='login-card px-4 py-4'>
              <Card.Body>
                <div className='logo'>
                  <img alt='solarSharelogo' src={solarSharelogo} />
                </div>
                <div className='title'><h3>Forgot your password ?</h3></div>
                <div className='caption'><p>We'll send the password reset link to your email.</p></div>
                <div className='login-form'>
                  <Form>
                    <Form.Group className="mb-3" controlId="email">
                      <Form.Control
                        disabled
                        type="email"
                        value={location.state.username ? location.state.username : ''}
                      />
                    </Form.Group>
                    {
                      (!succuss && !failure) ? <Form.Group className="mb-5" controlId="lockCheckbox">
                        <Button variant="primary" onClick={() => handleSubmit()}>
                          Send Reset Link
                        </Button>
                      </Form.Group> : <>
                        {
                          (hideNotification) ? <></> : <Toast
                            style={{
                              backgroundColor: (succuss) ? '#5cb85c' : '#d9534f',
                            }}
                            className='notification'
                            onClose={() => setHideNotification(true)}
                            delay={4000} autohide>
                            <Toast.Body>
                              {(succuss) ? `We have emailed your password reset link.` : `Error while sending reset password link`}
                            </Toast.Body>
                          </Toast>
                        }

                        <div className='forgotPassword-button' onClick={() => navigate('/login')}>
                          Back to Sign In ?
                        </div>
                      </>
                    }
                  </Form>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default ForgotPassword;